var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var sessions = [
    {
        start: '2022-11-14 09:00:00 UTC',
        end: '2022-11-14 10:15:00 UTC',
        name: 'D1.1 Mo Gawdat: Scary Smart: The future of technology, AI, robotics and ethics'
    },
    {
        start: '2022-11-14 10:30:00 UTC',
        end: '2022-11-14 11:15:00 UTC',
        name: 'D1.2 Auditing & Pentesting Industrial Control Systems (ICS): Welcome to the garden of a thousand surprises'
    },
    {
        start: '2022-11-14 11:15:00 UTC',
        end: '2022-11-14 12:00:00 UTC',
        name: 'D1.3 ICS Security: The challenges, pitfalls and solutions'
    },
    {
        start: '2022-11-14 12:00:00 UTC',
        end: '2022-11-14 12:45:00 UTC',
        name: 'D1.4 KPMG: Improving the Efficiency of Cybersecurity by Leveraging IT/OT Convergence'
    },
    {
        start: '2022-11-14 12:45:00 UTC',
        end: '2022-11-14 13:30:00 UTC',
        name: 'D1.5 Cyberthreats in Space'
    },
    {
        start: '2022-11-14 13:30:00 UTC',
        end: '2022-11-14 14:15:00 UTC',
        name: 'D1.6 Strange Hill to Die on: Building an effective programme whilst balancing egos'
    },
    {
        start: '2022-11-14 14:15:00 UTC',
        end: '2022-11-14 15:00:00 UTC',
        name: 'D1.7 CybelAngel: Exposed Doors and Lost Keys: Gaining visibility across your Digital Footprint'
    },
    {
        start: '2022-11-14 15:00:00 UTC',
        end: '2022-11-14 15:45:00 UTC',
        name: 'D1.8 Engaging with Leaders: A journey to bring security to the heart of the organisation'
    },
    {
        start: '2022-11-14 15:45:00 UTC',
        end: '2022-11-14 16:30:00 UTC',
        name: 'D1.9 Crowdstrike: Perspectives on eCrime: An ever-diversifying ecosystem'
    },
    {
        start: '2022-11-14 16:30:00 UTC',
        end: '2022-11-14 17:30:00 UTC',
        name: 'D1.10 Toomas Ilves: The Challenge of Today’s Global Digital Stage'
    },
    {
        start: '2022-11-15 09:00:00 UTC',
        end: '2022-11-15 10:15:00 UTC',
        name: 'D2.1 Omera Khan: Accelerate or Die… Future-Proofing our supply chain'
    },
    {
        start: '2022-11-15 10:30:00 UTC',
        end: '2022-11-15 11:15:00 UTC',
        name: 'D2.2 Security for Champions'
    },
    {
        start: '2022-11-15 11:15:00 UTC',
        end: '2022-11-15 12:00:00 UTC',
        name: 'D2.3 A Quest to Tame DevOps unicorns: A story of epic failures and success'
    },
    {
        start: '2022-11-15 11:15:00 UTC',
        end: '2022-11-15 12:00:00 UTC',
        name: 'D2.3 Engaged Reporting to Earn the Trust of Senior Management'
    },
    {
        start: '2022-11-15 12:00:00 UTC',
        end: '2022-11-15 12:45:00 UTC',
        name: 'D2.4 Huawei Technologies: From Product Security to Operational Security (GSMA 5G Cyber Security Knowledge Base in Practice)'
    },
    {
        start: '2022-11-15 12:45:00 UTC',
        end: '2022-11-15 13:30:00 UTC',
        name: 'D2.5 Controlling the Controls'
    },
    {
        start: '2022-11-15 13:30:00 UTC',
        end: '2022-11-15 14:15:00 UTC',
        name: 'D2.6 The Challenges Facing Leaders Today'
    },
    {
        start: '2022-11-15 14:15:00 UTC',
        end: '2022-11-15 15:00:00 UTC',
        name: 'D2.7 SureCloud: Finally Deliver GRC Outcomes: Introducing the age of the capability'
    },
    {
        start: '2022-11-15 15:00:00 UTC',
        end: '2022-11-15 15:45:00 UTC',
        name: 'D2.8 A Journey of Building Supply Chain Assurance, Monitoring Supplier Security'
    },
    {
        start: '2022-11-15 15:45:00 UTC',
        end: '2022-11-15 16:30:00 UTC',
        name: 'D2.9 IBM Security: X-Force Cloud Threat Landscape Report'
    },
    {
        start: '2022-11-15 16:30:00 UTC',
        end: '2022-11-15 17:30:00 UTC',
        name: 'D2.10 Jamie Bartlett: The Billion-Dollar Crypto Scam'
    },
    {
        start: '2022-11-16 09:00:00 UTC',
        end: '2022-11-16 10:00:00 UTC',
        name: 'D3.1 Margaret Heffernan: You Have the Attention of the Board. Now What? Navigating an uncertain future'
    },
    {
        start: '2022-11-16 10:30:00 UTC',
        end: '2022-11-16 11:15:00 UTC',
        name: 'D3.2 The New ISF Supplier Security WebApp: Assess your suppliers with ease'
    },
    {
        start: '2022-11-16 11:15:00 UTC',
        end: '2022-11-16 12:00:00 UTC',
        name: 'D3.3 Building and Embedding a Security Culture at a Rapidly Growing and Agile Fintech Scale-Up Organisation'
    },
    {
        start: '2022-11-16 12:00:00 UTC',
        end: '2022-11-16 12:45:00 UTC',
        name: 'D3.4 BlueVoyant: The Evolution of Supply Chain Cyber Defence: A pragmatic approach'
    },
    {
        start: '2022-11-16 12:45:00 UTC',
        end: '2022-11-16 13:30:00 UTC',
        name: 'D3.5 Challenging Your Leadership in Cyber'
    },
    {
        start: '2022-11-16 13:30:00 UTC',
        end: '2022-11-16 14:15:00 UTC',
        name: "D3.6 What's the Point of Appetite? How I learned to love appetite to feed security"
    },
    {
        start: '2022-11-16 14:15:00 UTC',
        end: '2022-11-16 15:00:00 UTC',
        name: 'D3.7 SecurityScorecard: Are we Prepared for the World Cup?'
    },
    {
        start: '2022-11-16 15:00:00 UTC',
        end: '2022-11-16 15:45:00 UTC',
        name: 'D3.8 Human Intelligence: Taking down insider threats with insider knowledge'
    },
    {
        start: '2022-11-16 15:45:00 UTC',
        end: '2022-11-16 16:30:00 UTC',
        name: 'D3.9 Policies and Standards Masterclass'
    },
    {
        start: '2022-11-16 16:30:00 UTC',
        end: '2022-11-16 17:30:00 UTC',
        name: 'D3.10 Rahaf Harfoush: Leading Through Emerging Technology and Digital Culture'
    }
].map(function (it, id) { return (__assign(__assign({}, it), { id: id + 1, title: it.name })); });
export default sessions;
